export function sortDataSource(data: any, sortHeaderId: string) {
    const keys = sortHeaderId.split('.');

    try {
      return keys.reduce((property, key) => property[key], data);
    } catch (error) {
      return null;
    }
};
